import type { AxiosInstance } from 'axios'
import qs from 'qs'

interface FetchUserDetailsResponse {
  id: number
  first_name: string
  last_name: string
  email: string
  full_name: string
  roles: Array<AccountUserRole>
  is_active: boolean
  status: string
  created_at: string
  updated_at: string
  deactivated_at: string | null
  last_login: string | null
}

interface SendInvitePayload {
  first_name: string
  last_name: string
  email: string
  roles?: AccountUserRole[] | null
  note?: string | null
}

interface UpdateUserPayload {
  first_name?: string
  last_name?: string
  roles?: AccountUserRole[]
}

interface ReactivateUserPayload {
  roles: AccountUserRole[]
}

export default (axios: AxiosInstance) => ({
  fetchUserDetails() {
    return axios.get<FetchUserDetailsResponse>('/v2/accounts/me/')
  },
  sendInvite(payload: SendInvitePayload) {
    return axios.post('/v2/accounts/users/invite/', payload)
  },
  getUsers(params?: ManageUsersQueryParams) {
    return axios.get<PaginatedResponse<ManageUser>>('/v2/accounts/users/', {
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  },
  deactivateUser(userId: number) {
    return axios.put(`/v2/accounts/users/${userId}/deactivate/`)
  },
  updateUser(userId: number, payload: UpdateUserPayload) {
    return axios.patch(`/v2/accounts/users/${userId}/`, payload)
  },
  resendInvitation(invitationId: number) {
    return axios.post(`/v2/accounts/invitations/${invitationId}/resend/`)
  },
  revokeInvitation(invitationId: number) {
    return axios.post(`/v2/accounts/invitations/${invitationId}/revoke/`)
  },
  reactivateUser(userId: number, payload: ReactivateUserPayload) {
    return axios.put(`/v2/accounts/users/${userId}/activate/`, payload)
  },
  acceptInvitation(token: string) {
    return axios.post('/v2/accounts/invitations/accept/', null, {
      params: { token },
    })
  },
})
